import { DataLoaderOptions } from '../../types';
import { areaPathsToI18n, booleanToI18n, emptyDateToI18n } from './valuesToI18n';

const buildDatasetInfoBoard = (data: DataLoaderOptions) => {
  const {
    name = '',
    board = '',
    teams = [],
    isDefaultAreaPaths = false,
    isCrossProject = false,
    createdDate = '',
    resolvedDate = '',
  } = data;
  return [
    {
      title: {
        id: 'information.dataSet.name',
        defaultMessage: 'Name',
        description: 'Information Popover Text',
      },
      data: name,
    },
    {
      title: {
        id: 'information.dataSet.team.board',
        defaultMessage: 'Team',
        description: 'Information Popover Data Text',
      },
      data: teams,
    },
    {
      title: {
        id: 'information.dataSet.board',
        defaultMessage: 'Board',
        description: 'Information Popover Text',
      },
      data: board,
    },
    {
      title: {
        id: 'information.dataSet.areaPaths',
        defaultMessage: 'Area Paths',
        description: 'Information Popover Text',
      },
      data: areaPathsToI18n(isDefaultAreaPaths),
      isDataI18n: true,
    },
    {
      title: {
        id: 'information.dataSet.crossProject',
        defaultMessage: 'Cross-Project History',
        description: 'Information Popover Text',
      },
      data: booleanToI18n(isCrossProject),
      isDataI18n: true,
    },
    {
      title: {
        id: 'information.dataSet.created',
        defaultMessage: 'Created After',
        description: 'Information Popover Text',
      },
      data: createdDate || emptyDateToI18n(),
      isDataI18n: !createdDate,
    },
    {
      title: {
        id: 'information.dataSet.resolved',
        defaultMessage: 'Resolved After',
        description: 'Information Popover Text',
      },
      data: resolvedDate || emptyDateToI18n(),
      isDataI18n: !resolvedDate,
    },
  ];
};

const buildDatasetInfoState = (data: DataLoaderOptions) => {
  const {
    name = '',
    teams = [],
    isDefaultAreaPaths = false,
    isCrossProject = false,
    createdDate = '',
    resolvedDate = '',
  } = data;

  const isMultipleTeams = teams.length > 1;
  return [
    {
      title: {
        id: 'information.dataSet.name',
        defaultMessage: 'Name',
        description: 'Information Popover Text',
      },
      data: name,
    },
    {
      title: {
        id: 'information.dataSet.team.state',
        defaultMessage: 'Team(s)',
        description: 'Information Popover Data Text',
      },
      data: teams,
      isArray: isMultipleTeams,
    },
    {
      title: {
        id: 'information.dataSet.areaPaths',
        defaultMessage: 'Area Paths',
        description: 'Information Popover Text',
      },
      data: areaPathsToI18n(isDefaultAreaPaths),
      isDataI18n: true,
    },
    {
      title: {
        id: 'information.dataSet.crossProject',
        defaultMessage: 'Cross-Project History',
        description: 'Information Popover Text',
      },
      data: booleanToI18n(isCrossProject),
      isDataI18n: true,
    },
    {
      title: {
        id: 'information.dataSet.created',
        defaultMessage: 'Created After',
        description: 'Information Popover Text',
      },
      data: createdDate || emptyDateToI18n(),
      isDataI18n: !createdDate,
    },
    {
      title: {
        id: 'information.dataSet.resolved',
        defaultMessage: 'Resolved After',
        description: 'Information Popover Text',
      },
      data: resolvedDate || emptyDateToI18n(),
      isDataI18n: !resolvedDate,
    },
  ];
};

const buildDatasetInfoQuery = (data: DataLoaderOptions) => {
  const { name = '', isCrossProject = false, queryTitle } = data;
  return [
    {
      title: {
        id: 'information.dataSet.name',
        defaultMessage: 'Name',
        description: 'Information Popover Text',
      },
      data: name,
    },
    {
      title: {
        id: 'information.dataSet.query',
        defaultMessage: 'Query',
        description: 'Information Popover Text',
      },
      data: queryTitle,
    },
    {
      title: {
        id: 'information.dataSet.crossProject',
        defaultMessage: 'Cross-Project History',
        description: 'Information Popover Text',
      },
      data: booleanToI18n(isCrossProject),
      isDataI18n: true,
    },
  ];
};

const buildDatasetInfoData = (data: DataLoaderOptions) => {
  const { loadMode } = data;

  if (loadMode === 'boardColumns') return buildDatasetInfoBoard(data);
  if (loadMode === 'workflowStates') return buildDatasetInfoState(data);
  if (loadMode === 'query') return buildDatasetInfoQuery(data);

  console.warn('Failed to build DatasetInfo for current dataset');
  return [];
};

export default buildDatasetInfoData;
